// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const ReportStatisticElementContent = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  background-image: linear-gradient(
    223deg,
    ${COLORS.rainbowIndigo} 0%,
    ${COLORS.rainbowIndigo} 100%
  );
  border-radius: 5px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextContainer = styled.div`
  font-family: ${FONTS.newsharp};
  margin-left: 20px;
  display: flex;
  flex-direction: column;
`;

export const TextContainerSubtitle = styled.div`
  color: ${COLORS.cornflowerBlue};
  font-size: 22px;
  font-weight: bold;
  @media (${WIDTH.mediumWidth}) {
    font-size: 17px;
  }
`;

export const TextContainerInfo = styled.div`
  font-size: 20px;
  font-weight: bold;
  @media (${WIDTH.mediumWidth}) {
    font-size: 15px;
  }
`;
